import * as _actions from './ducks/actions'
import reducer from './ducks/reducer'

export { _actions as portfolioActions }

export default reducer
